import { render, staticRenderFns } from "./title-bar.vue?vue&type=template&id=1420303e&scoped=true"
import script from "./title-bar.vue?vue&type=script&lang=js"
export * from "./title-bar.vue?vue&type=script&lang=js"
import style0 from "./title-bar.vue?vue&type=style&index=0&id=1420303e&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1420303e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1420303e')) {
      api.createRecord('1420303e', component.options)
    } else {
      api.reload('1420303e', component.options)
    }
    module.hot.accept("./title-bar.vue?vue&type=template&id=1420303e&scoped=true", function () {
      api.rerender('1420303e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/title-bar.vue"
export default component.exports